export const SET_UNREAD_COUNT = 'unreadCount';
export const SET_CLIENT_ROOM = 'setClientRoom';
export const SET_EMPLOYEE_ROOMS = 'setEmployeeRooms';
export const SET_PARTICIPANTS = 'setParticipants';
export const SET_SELECTED_CHAT = 'setSelectedChat';
